import ServicePage from './ServicePage';
import { Plane, Shield } from 'lucide-react';

const PROVIDERS = [
  { name: 'AirHelp', desc: 'Flight delayed, cancelled, or overbooked? Claim up to $600 compensation. No win, no fee — check eligibility in 2 minutes.', url: 'https://airhelp.tpm.lv/PWwYaq5O', icon: Plane, color: 'from-red-500 to-red-600', tagline: 'Up to $600 Compensation' },
  { name: 'Compensair', desc: 'Get money back for flight disruptions. Simple claim process, expert legal support, and you only pay if you win.', url: 'https://compensair.tpm.lv/ZOWHHas3', icon: Shield, color: 'from-purple-500 to-purple-600', tagline: 'No Win, No Fee' },
];

export default function FlightCompensationPage() {
  return <ServicePage title="Flight Compensation" subtitle="Claim compensation for delayed, cancelled, or overbooked flights — hassle-free." icon={Plane} providers={PROVIDERS} testId="flight-compensation-page" />;
}
